let valid = {
  //只支持大写英文
  _limitUpperEn(i) {
    var validFormat = /^[A-Z]{1,20}$/;
    return validFormat.test(i);
  },
  //2-50字，支持中英文数字
  __limit2or50_ZhorEnorNumber(i) {
    var validFormat = /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9]){2,50}$/;
    return validFormat.test(i);
  },
  //2-20字，支持中英文
  _limit2or20_ZhorEn(i) {
    var validFormat = /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z]){2,20}$/;
    return validFormat.test(i);
  },
  //11位手机号
  _limitPhone(i) {
    var validFormat = /^[1][0-9]{10}$/;
    return validFormat.test(i);
  },
  //1-20字，支持中英文数字
  _limit2or20_ZhorEnorNumber(i) {
    var validFormat = /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9]){1,20}$/;
    return validFormat.test(i);
  },

  //2-20字，支持中英文数字
  _limit2or20_ZhorEnorNumberA(i) {
    var validFormat = /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9]){2,20}$/;
    return validFormat.test(i);
  },

  //邮箱
  _limitemail(i) {
    var validFormat =
      /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
    return validFormat.test(i);
  },
  //至少6位，需含有数字和字母，字母区分大小写
  _limitPwd(i) {
    var validFormat = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,20}$/;
    return validFormat.test(i);
  },
  //0-30字，支持中英文数字
  _limit0or30_ZhorEnorNumber(i) {
    var validFormat = /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9]){1,30}$/;
    return validFormat.test(i);
  },

  //- 校验url
  checkUrl(textval) {
    const pathregex = /^(http:\/\/|https:\/\/)+([A-Za-z0-9]+[\s\S]*)$/;
    return pathregex.test(textval);
  },
  //大写3数字3
  A3N3(i) {
    var validFormat = /^[A-z]{3}\d{3}$/;
    return validFormat.test(i);
  },

  //1-20字，支持中英文
  _limit1or20_ZhorEn(i) {
    var validFormat = /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z]){1,20}$/;
    return validFormat.test(i);
  },

  // 账号（包含字母数字下划线，6至20位）
  _regAccount(i) {
    var validFormat = /^([A-Za-z]|\d|_){4,20}$/;
    return validFormat.test(i);
  },
  // 账号校验
  checkAccount(i) {
    var validaFormat = /^([A-Za-z]|\d|_){4,20}$/;
    return validaFormat.test(i);
  },
  // 小数点前后限制
  checkPrice(i) {
    var validaFormat = /^[0-9]{1,7}(\.[0-9]{0,2})?$/;
    return validaFormat.test(i);
  },
};

export default valid;
